import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PollingEffects } from './store/polling.effects';
import { pollingReducer } from './store/polling.reducer';
import { POLLING_FEATURE_KEY } from './store/polling.selector';

@NgModule({
  imports: [
    EffectsModule.forFeature([PollingEffects]),
    StoreModule.forFeature(POLLING_FEATURE_KEY, pollingReducer),
  ],
})
export class PollingModule {}
